(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const controllers = new WeakMap();
    const initializeScrollGlass = () => {
      const header = document.querySelector('#header-component[data-scroll-glass]');
      if (!header) return;
      controllers.get(header)?.abort();
      const controller = new AbortController();
      controllers.set(header, controller);
      const { signal } = controller;
      const rail = header.parentElement.querySelector('[data-hp-acrylic-rail]');
      const rows = Array.from(header.querySelectorAll(':scope > .header__row'));
      if (rail) {
        rail.dataset.hpVisible = 'false';
        rail.setAttribute('aria-hidden', 'true');
        rail.inert = true;
        rail.hidden = false;
        rail.getBoundingClientRect();
      }
      let frame = null;
      let glowFrame = null;
      let glowPoint = null;
      let scrolled = null;
      const hideGlow = () => {
        header.dataset.hpGlow = 'false';
        if (glowFrame !== null) cancelAnimationFrame(glowFrame);
        glowFrame = null;
      };
      header.addEventListener('pointermove', event => {
        if (event.pointerType === 'touch' || header.dataset.hpRailActive === 'true') return;
        glowPoint = { x: event.clientX, y: event.clientY };
        if (glowFrame !== null) return;
        glowFrame = requestAnimationFrame(() => {
          glowFrame = null;
          const bounds = header.getBoundingClientRect();
          const x = glowPoint.x - bounds.left;
          const y = glowPoint.y - bounds.top;
          if (x < 0 || x > bounds.width || y < 0 || y > bounds.height) { hideGlow(); return; }
          header.style.setProperty('--hp-glow-x', `${x}px`);
          header.style.setProperty('--hp-glow-y', `${y}px`);
          header.dataset.hpGlow = 'true';
        });
      }, { passive: true, signal });
      header.addEventListener('pointerleave', hideGlow, { signal });
      const controls = node => Array.from(node?.querySelectorAll('a[href], button') || []);
      const actionFor = element => {
        if (element?.closest?.('search-button, .search-action')) return 'search';
        if (element?.closest?.('[aria-controls="cart-drawer"], .action__cart, [data-testid="cart-drawer-trigger"]')) return 'cart';
        if (element?.closest?.('.account-button, shopify-account')) return 'account';
        if (element?.closest?.('.header-logo')) return 'home';
        return element?.closest?.('[data-hp-action]')?.dataset.hpAction;
      };
      const getPageScrollTop = () => {
        const wrapper = document.querySelector('.page-wrapper');
        if (wrapper && wrapper.clientHeight > 0 && wrapper.scrollHeight > wrapper.clientHeight) {
          const overflow = getComputedStyle(wrapper).overflowY;
          if (['auto', 'scroll', 'overlay'].includes(overflow)) return wrapper.scrollTop;
        }
        return window.scrollY || document.scrollingElement?.scrollTop || 0;
      };
      const update = () => {
        if (!header.isConnected) { controller.abort(); return; }
        const parsedThreshold = Number(header.dataset.glassThreshold);
        const threshold = Number.isFinite(parsedThreshold) ? parsedThreshold : 40;
        const scrollTop = getPageScrollTop();
        scrolled = scrolled === null ? scrollTop > threshold : scrolled ? scrollTop > Math.max(0, threshold - 12) : scrollTop > threshold;
        header.dataset.glassScrolled = String(scrolled);
        const active = Boolean(scrolled && rail);
        if (active) hideGlow();
        if (header.dataset.hpRailActive !== String(active)) {
          const focused = document.activeElement;
          const wasInRail = rail?.contains(focused);
          const wasInHeader = header.contains(focused) && !focused?.closest?.('dialog[open]');
          const href = focused?.closest?.('a[href]')?.getAttribute('href');
          const action = actionFor(focused);
          header.dataset.hpRailActive = String(active);
          rows.forEach(row => { row.inert = active; });
          if (rail) {
            rail.dataset.hpVisible = String(active);
            rail.setAttribute('aria-hidden', String(!active));
            rail.inert = !active;
          }
          if ((active && wasInHeader) || (!active && wasInRail)) {
            const destination = active ? rail : header;
            const candidates = controls(destination).filter(element => getComputedStyle(element).visibility !== 'hidden' && element.getClientRects().length);
            const equivalent = candidates.find(element => action && actionFor(element) === action)
              || candidates.find(element => href && element.getAttribute('href') === href)
              || candidates[0];
            equivalent?.focus({ preventScroll: true });
          }
        } else if (rail && rail.dataset.hpVisible !== String(active)) {
          rail.dataset.hpVisible = String(active);
          rail.setAttribute('aria-hidden', String(!active));
          rail.inert = !active;
          rows.forEach(row => { row.inert = active; });
        }
      };
      const scheduleUpdate = () => {
        if (frame !== null) return;
        frame = requestAnimationFrame(() => { frame = null; update(); });
      };
      rail?.addEventListener('click', event => {
        const control = event.target.closest('[data-hp-action]');
        if (!control || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (control.dataset.hpAction === 'search') {
          const modal = document.getElementById('search-modal');
          if (typeof modal?.showDialog === 'function') {
            event.preventDefault();
            modal.showDialog();
          }
        }
        if (control.dataset.hpAction === 'cart') {
          const trigger = header.querySelector('button[data-testid="cart-drawer-trigger"], button[aria-controls="cart-drawer"]');
          if (trigger) {
            event.preventDefault();
            trigger.click();
          }
        }
      }, { signal });
      document.addEventListener('scroll', event => {
        const target = event.target;
        if (target === document || target === document.scrollingElement || target?.matches?.('.page-wrapper')) scheduleUpdate();
      }, { capture: true, passive: true, signal });
      window.addEventListener('resize', scheduleUpdate, { passive: true, signal });
      window.addEventListener('pageshow', scheduleUpdate, { signal });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target?.contains?.(header)) controller.abort();
      }, { signal });
      signal.addEventListener('abort', () => {
        if (frame !== null) cancelAnimationFrame(frame);
        hideGlow();
        if (rail) rail.hidden = true;
        rows.forEach(row => { row.inert = false; });
      }, { once: true });
      update();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeScrollGlass, { once: true });
    else initializeScrollGlass();
    document.addEventListener('shopify:section:load', initializeScrollGlass);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      root.querySelectorAll('.hph-hero__video-toggle').forEach((button) => {
        if (button.dataset.initialized) return;

        const video = button.closest('.hph-hero').querySelector('video');
        if (!video) return;

        button.dataset.initialized = 'true';

        const update = () => {
          button.textContent = video.paused
            ? button.dataset.playLabel
            : button.dataset.pauseLabel;
        };

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.autoplay = false;
          video.pause();
        }

        button.addEventListener('click', () => {
          if (video.paused) {
            video.play().catch(update);
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', update);
        video.addEventListener('pause', update);
        update();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => init(document),
        { once: true }
      );
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hover-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('upscale-product-hover')) {
    customElements.define('upscale-product-hover', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.stage = this.querySelector('[data-stage]');
        this.image = this.stage.querySelector('.uph__stage-image');
        this.empty = this.stage.querySelector('[data-empty]');
        this.sources = new Map([['all', {
          src: this.stage.dataset.defaultSrc,
          srcset: this.stage.dataset.defaultSrcset,
          alt: this.stage.dataset.defaultAlt,
          position: this.stage.dataset.defaultPosition
        }]]);
        this.cards.forEach(card => {
          if (!card.dataset.previewSrc) return;
          this.sources.set(card.dataset.card, {
            src: card.dataset.previewSrc,
            srcset: card.dataset.previewSrcset,
            alt: card.dataset.previewAlt,
            position: card.dataset.previewPosition
          });
        });
        this.cache = new Map();
        this.status = this.querySelector('[data-status]');
        this.hoverId = null;
        this.focusId = null;
        this.pinnedId = null;
        this.lastPointer = null;
        this.revision = 0;
        this.scroller = this.querySelector('[data-product-row]');
        this.scrollControls = this.querySelector('[data-scroll-controls]');
        this.scrollIndicator = this.querySelector('[data-scroll-indicator]');
        this.previousButton = this.querySelector('[data-scroll-previous]');
        this.nextButton = this.querySelector('[data-scroll-next]');
        this.scroller.addEventListener('scroll', () => this.updateScroll(), { ...options, passive: true });
        this.previousButton.addEventListener('click', () => this.scrollProducts(-1), options);
        this.nextButton.addEventListener('click', () => this.scrollProducts(1), options);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateScroll());
          this.resizeObserver.observe(this.scroller);
          this.cards.forEach(card => this.resizeObserver.observe(card));
        } else {
          window.addEventListener('resize', () => this.updateScroll(), options);
        }

        this.cards.forEach(card => {
          card.addEventListener('pointerenter', event => {
            if (event.pointerType === 'touch') return;
            this.hoverId = card.dataset.card;
            this.update();
          }, options);
          card.addEventListener('pointerleave', event => {
            if (event.pointerType === 'touch') return;
            this.hoverId = null;
            this.update();
          }, options);
          card.addEventListener('pointerdown', event => {
            this.lastPointer = event.pointerType;
            if (event.pointerType !== 'touch') this.focusId = null;
          }, options);
          card.querySelector('[data-preview-button]').addEventListener('click', () => {
            if (this.lastPointer === 'touch' || !window.matchMedia('(any-hover: hover)').matches) {
              this.pinnedId = this.pinnedId === card.dataset.card ? null : card.dataset.card;
              this.focusId = null;
              this.update(true);
            }
          }, options);
        });

        this.addEventListener('focusin', event => {
          const card = event.target.closest('[data-card]');
          this.focusId = card && event.target.matches(':focus-visible') ? card.dataset.card : null;
          this.update(true);
        }, options);
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) {
            this.focusId = null;
            this.update();
          }
        }, options);
        this.addEventListener('keydown', event => {
          this.lastPointer = null;
          if (event.key === 'Escape') {
            this.hoverId = this.focusId = this.pinnedId = null;
            this.update(true);
          } else {
            const card = event.target.closest('[data-card]');
            if (card) {
              this.focusId = card.dataset.card;
              this.update(true);
            }
          }
        }, options);
        this.querySelector('[data-show-all]').addEventListener('click', () => {
          this.hoverId = this.focusId = this.pinnedId = null;
          this.update(true);
        }, options);
        this.addEventListener('shopify:block:select', event => {
          this.pinnedId = event.detail.blockId;
          this.update();
        }, options);
        this.addEventListener('shopify:block:deselect', () => {
          this.pinnedId = null;
          this.update();
        }, options);
        this.updateScroll();
        this.update();
      }

      disconnectedCallback() {
        this.revision += 1;
        if (this.controller) this.controller.abort();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.resizeObserver = null;
        this.controller = null;
      }

      updateScroll() {
        const maximum = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
        const isRtl = window.getComputedStyle(this.scroller).direction === 'rtl';
        const position = Math.max(0, Math.min(maximum, isRtl ? -this.scroller.scrollLeft : this.scroller.scrollLeft));
        const progress = maximum > 0 ? position / maximum : 0;
        const fraction = this.scroller.scrollWidth > 0 ? Math.min(1, Math.max(0.12, this.scroller.clientWidth / this.scroller.scrollWidth)) : 1;
        this.scrollControls.hidden = maximum <= 1;
        this.previousButton.disabled = position <= 1;
        this.nextButton.disabled = maximum - position <= 1;
        this.scrollIndicator.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
        this.scrollIndicator.style.setProperty('--uph-thumb-size', (fraction * 100) + '%');
        this.scrollIndicator.style.setProperty('--uph-thumb-position', ((isRtl ? 1 - progress : progress) * (1 - fraction) * 100) + '%');
      }

      scrollProducts(direction) {
        const style = window.getComputedStyle(this.scroller);
        const isRtl = style.direction === 'rtl';
        const maximum = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
        const position = Math.max(0, Math.min(maximum, isRtl ? -this.scroller.scrollLeft : this.scroller.scrollLeft));
        const width = this.cards[0]?.getBoundingClientRect().width || this.scroller.clientWidth * 0.8;
        const step = width + (parseFloat(style.columnGap) || 0);
        const destination = Math.max(0, Math.min(maximum, position + direction * step));
        this.scroller.scrollTo({
          left: isRtl ? -destination : destination,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      update(announce = false) {
        const controller = this.controller;
        const wanted = this.hoverId || this.focusId || this.pinnedId || 'all';
        const id = this.sources.has(wanted) ? wanted : 'all';
        const source = this.sources.get(id);
        const revision = ++this.revision;
        const apply = () => {
          if (!this.isConnected || this.controller !== controller || this.revision !== revision) return;
          if (source.src) {
            this.image.loading = 'eager';
            this.image.sizes = this.stage.dataset.imageSizes;
            this.image.srcset = source.srcset || '';
            if (this.image.getAttribute('src') !== source.src) this.image.src = source.src;
          } else {
            this.image.removeAttribute('srcset');
            this.image.removeAttribute('src');
          }
          this.image.alt = source.alt || '';
          this.image.style.objectPosition = source.position || '50% 50%';
          this.image.hidden = !source.src;
          this.empty.hidden = Boolean(source.src);
          this.cards.forEach(card => {
            const selected = card.dataset.card === id;
            card.classList.toggle('is-selected', selected);
            card.querySelector('[data-preview-button]').setAttribute('aria-pressed', String(selected));
          });
          if (announce && this.status) {
            const card = this.cards.find(item => item.dataset.card === id);
            this.status.textContent = card
              ? this.status.dataset.previewLabel.replace('[title]', card.querySelector('.uph__title').textContent.trim())
              : this.status.dataset.allLabel;
          }
        };
        if (id === 'all' || !source.src) {
          apply();
          return;
        }
        const key = source.src + '|' + source.srcset;
        let entry = this.cache.get(key);
        if (entry && entry.ready) {
          apply();
          return;
        }
        if (!entry) {
          const loader = new Image();
          entry = { ready: false };
          entry.promise = new Promise(resolve => {
            loader.onload = () => {
              entry.ready = true;
              loader.onload = loader.onerror = null;
              resolve(true);
            };
            loader.onerror = () => {
              loader.onload = loader.onerror = null;
              resolve(false);
            };
          });
          this.cache.set(key, entry);
          loader.sizes = this.stage.dataset.imageSizes;
          loader.srcset = source.srcset || '';
          loader.src = source.src;
        }
        entry.promise.then(loaded => {
          if (!this.isConnected || this.controller !== controller || this.revision !== revision) return;
          if (loaded) {
            apply();
          } else {
            this.hoverId = this.focusId = this.pinnedId = null;
            this.update();
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hp-video-smooth')) {
    customElements.define('hp-video-smooth', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || this.pendingInit) return;
        this.pendingInit = true;
        this.readyHandler = () => {
          this.pendingInit = false;
          if (this.isConnected) this.initialize();
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.readyHandler, { once: true });
        } else {
          queueMicrotask(this.readyHandler);
        }
      }

      initialize() {
        if (this.controller || !this.isConnected) return;
        this.video = this.querySelector('.hpvh__video');
        this.canvas = this.querySelector('.hpvh__canvas');
        this.scene = this.querySelector('.hpvh__scene');
        this.stage = this.querySelector('.hpvh__stage');
        this.frame = this.querySelector('.hpvh__frame');
        this.copy = this.querySelector('.hpvh__copy');
        if (!this.video || !this.scene || !this.stage || !this.frame || !this.copy) {
          if (!this.childObserver) {
            this.childObserver = new MutationObserver(() => this.initialize());
            this.childObserver.observe(this, { childList: true, subtree: true });
          }
          return;
        }
        this.childObserver?.disconnect();
        this.childObserver = null;
        this.controller = new AbortController();
        this.context = null;
        try {
          this.context = this.canvas?.getContext('2d') || null;
        } catch (error) {
          this.context = null;
        }
        if (this.context) this.context.filter = 'blur(8px) saturate(1.15)';
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.failed = false;
        this.ambientReady = false;
        this.currentProgress = 0;
        this.currentScale = 1;
        this.revealed = false;
        this.needsMeasure = false;
        this.scrollBusyUntil = 0;
        this.targetProgress = 0;
        this.scrollFrame = 0;
        this.ambientTimer = 0;
        const options = { signal: this.controller.signal };
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.playsInline = true;
        this.video.controls = false;
        this.video.disablePictureInPicture = true;
        this.video.addEventListener('playing', () => this.startAmbient(), options);
        this.video.addEventListener('pause', () => this.stopAmbient(), options);
        this.video.addEventListener('loadeddata', () => this.drawAmbient(), options);
        this.video.addEventListener('error', () => this.stopAmbient(), options);
        document.addEventListener('scroll', () => this.measure(), { passive: true, capture: true, ...options });
        window.addEventListener('scroll', () => this.measure(), { passive: true, ...options });
        window.addEventListener('resize', () => {
          if (matchMedia('(pointer: coarse)').matches && this.clientWidth === this.lastWidth) return;
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => this.layout(), 120);
        }, options);
        document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
        this.motion.addEventListener('change', () => {
          this.measure();
          this.updatePlayback();
        }, options);
        this.resizeObserver = new ResizeObserver(entries => {
          const width = this.clientWidth;
          const copyHeight = this.copy.offsetHeight;
          if (width !== this.lastWidth || copyHeight !== this.lastCopyHeight) this.layout();
        });
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.copy);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.updatePlayback();
        }, { threshold: 0 });
        this.observer.observe(this.scene);
        this.layout();
        this.drawAmbient();
        document.fonts?.ready.then(() => {
          if (this.isConnected && this.controller) this.layout();
        });
      }

      layout() {
        this.lastWidth = this.clientWidth;
        this.lastCopyHeight = this.copy.offsetHeight;
        this.stage.style.height = 'var(--hpvh-height, 75svh)';
        this.baseHeight = this.stage.offsetHeight;
        const gap = parseFloat(getComputedStyle(this.scene).paddingTop) || 0;
        const copyGap = parseFloat(getComputedStyle(this.copy).marginTop) || 28;
        const available = window.innerHeight - gap - copyGap - this.lastCopyHeight - 28;
        const configured = Math.min(.85, Math.max(.35, Number(this.dataset.shrink || 65) / 100));
        this.minimumScale = Math.min(configured, Math.max(.35, available / this.baseHeight));
        const sceneHeight = Math.max(window.innerHeight, gap + this.baseHeight + 24,
          gap + this.baseHeight * this.minimumScale + copyGap + this.lastCopyHeight + 28);
        this.travel = Math.max(480, window.innerHeight);
        this.style.setProperty('--hpvh-scene-height', `${Math.ceil(sceneHeight)}px`);
        this.style.setProperty('--hpvh-travel', `${Math.ceil(this.travel)}px`);
        this.setAttribute('data-enhanced', '');
        this.applyProgress();
        this.measure();
      }

      updatePlayback() {
        if (this.visible && !document.hidden && !this.motion.matches) {
          const attempt = this.video.play();
          if (attempt) attempt.catch(() => {});
          this.startAmbient();
        } else {
          this.video.pause();
          this.stopAmbient();
        }
      }

      drawAmbient() {
        if (!this.context || this.failed || this.video.readyState < 2 || performance.now() < this.scrollBusyUntil) return;
        try {
          this.context.drawImage(this.video, -12, -8, this.canvas.width + 24, this.canvas.height + 16);
          if (!this.ambientReady) {
            this.ambientReady = true;
            this.setAttribute('data-ambient-ready', '');
          }
        } catch (error) {
          this.failed = true;
        }
      }

      startAmbient() {
        this.stopAmbient();
        if (!this.visible || document.hidden || this.motion.matches || this.video.paused || this.failed) return;
        const tick = () => {
          this.drawAmbient();
          if (this.visible && !document.hidden && !this.video.paused && !this.motion.matches && !this.failed) {
            this.ambientTimer = window.setTimeout(tick, 180);
          }
        };
        tick();
      }

      stopAmbient() {
        clearTimeout(this.ambientTimer);
        this.ambientTimer = 0;
      }

      measure() {
        if (!this.travel) return;
        this.needsMeasure = true;
        this.scrollBusyUntil = performance.now() + 180;
        if (!this.scrollFrame) {
          this.lastFrameTime = 0;
          this.scrollFrame = requestAnimationFrame(time => this.animateProgress(time));
        }
      }

      animateProgress(time) {
        if (this.needsMeasure) {
          const top = this.getBoundingClientRect().top;
          this.targetProgress = Math.min(1, Math.max(0, -top / this.travel));
          this.needsMeasure = false;
        }
        const delta = this.lastFrameTime ? Math.min(64, time - this.lastFrameTime) : 16.67;
        this.lastFrameTime = time;
        if (this.motion.matches) this.currentProgress = this.targetProgress;
        else this.currentProgress += (this.targetProgress - this.currentProgress) * (1 - Math.exp(-delta / 120));
        if (Math.abs(this.targetProgress - this.currentProgress) < .0001) this.currentProgress = this.targetProgress;
        this.applyProgress();
        if (this.needsMeasure || this.currentProgress !== this.targetProgress) {
          this.scrollFrame = requestAnimationFrame(next => this.animateProgress(next));
        } else {
          this.scrollFrame = 0;
        }
      }

      applyProgress() {
        const progress = this.currentProgress;
        const eased = progress * progress * (3 - 2 * progress);
        const scale = 1 - eased * (1 - this.minimumScale);
        let reveal = Math.min(1, Math.max(0, (progress - .12) / .64));
        if (this.motion.matches) reveal = progress > .12 ? 1 : 0;
        else reveal = reveal * reveal * (3 - 2 * reveal);
        const lift = this.motion.matches ? 0 : (1 - reveal) * 24;
        const copyOffset = this.baseHeight * (scale - 1) + lift;
        this.currentScale = scale;
        this.frame.style.transform = `translate3d(0, 0, 0) scale(${scale.toFixed(6)})`;
        this.copy.style.transform = `translate3d(0, ${copyOffset.toFixed(3)}px, 0)`;
        this.copy.style.opacity = reveal.toFixed(5);
        const revealed = reveal > 0;
        if (revealed !== this.revealed || !this.copy.hasAttribute('aria-hidden')) {
          this.revealed = revealed;
          this.toggleAttribute('data-revealed', revealed);
          this.copy.setAttribute('aria-hidden', revealed ? 'false' : 'true');
        }
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.readyHandler);
        this.childObserver?.disconnect();
        this.childObserver = null;
        this.pendingInit = false;
        this.controller?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.stopAmbient();
        cancelAnimationFrame(this.scrollFrame);
        clearTimeout(this.resizeTimer);
        this.video?.pause();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
